import Vue from 'vue';
import InputCountry from '../../../core/input/country/input-country';
import UtmData from '../../../base/script/utmData';
import recaptcha from '../../../base/script/recaptcha';
import Api from '../../../base/script/api';

export default function () {
  const popupCallback = document.querySelector('.popup-callback');
  const popupForm = popupCallback ? popupCallback.querySelector('.popup-callback__form') : null;
  const object = window.popupTitles;

  if (popupForm !== null) {
    const eventCategory = popupForm.getAttribute('data-eventcategory') || false;
    const defaultType = popupForm.getAttribute('data-type') || 'cellphone';
    new Vue({
      el: popupCallback,
      delimiters: ['${', '}}'],
      components: {
        InputCountry,
      },
      data() {
        return {
          object,
          isEmail: false,
          isCalculator: false,
          isQuestion: false,
          isNew: false,
          form: popupForm,
          title: object.common,
          chooseTime: 'now',
          chooseType: defaultType,
          formComplete: false,
          showError: false,
          isSubmited: false,
          nameValidation: false,
          observer: null,
          formData: {
            name: '',
            email: '',
            phone: null,
            callTime: null,
            question: null,
            type: defaultType,
            second_name: '',
            agree: false,
            agreeAds: false,
          },
        };
      },
      watch: {
        chooseTime() {
          if (this.chooseTime === 'now') {
            this.formData.callTime = 'now';
          } else {
            this.formData.callTime = '';
          }
        },
        chooseType(value) {
          if (this.formData.type) {
            this.submitEl.classList.remove(`connect-${this.formData.type}`);
          }
          this.formData.type = value;
          this.submitEl.classList.add(`connect-${value}`);
        },
      },
      methods: {
        initCaptcha() {
          recaptcha.add(this.submitEl, (token) => {
            if (this.$el.querySelector('[name="g-recaptcha-response"]').value === token) {
              window.grecaptcha.execute();
              this.formData['g-recaptcha-response'] = token;
              this.sendForm();
            }
          });
        },
        getPhonePrefix() {
          const phoneInput = this.$el.querySelector('input[data-phone-prefix]');
          if (phoneInput) {
            return `${phoneInput.getAttribute('data-phone-prefix')} `;
          }
          return '';
        },
        sendForm() {
          new UtmData(this.formData);
          // if (window.Comagic) {
          //   this.formData.comagic = window.Comagic.getCredentials();
          // }
          const copyObject = Object.assign({}, this.formData);
          copyObject.phone = `${this.getPhonePrefix()}${copyObject.phone}`;
          copyObject.stateless = window.stateless || 0;

          Api.post(this.form.action, copyObject)
            .then((response) => {
              const copyData = Object.assign({}, this.formData);
              const { data } = response;
              if (this.customForm) {
                this.customForm.reset();
                if (this.customPhone && this.customPhone.im) {
                  this.formComplete = false;
                  this.customPhone.im.updateValue();
                }
              }
              this.formData.name = '';
              this.formData.question = '';
              this.formData.email = '';
              this.formData.phone = '';
              this.formData.callTime = '';
              this.formData.second_name = '';
              this.isSubmited = false;
              if (eventCategory && window.ga) {
                window.ga('send', {
                  hitType: 'event',
                  eventCategory,
                  eventAction: 'lead',
                  eventLabel: 'form',
                });
              }
              if (data.success) {
                window.openSuccessPopup();
                if (copyData.type) { // отправка данных в comagic и chat
                  if (copyData.type === 'call' || copyData.type === 'cellphone') {
                    if (window.Comagic && window.Comagic.addOfflineRequest) {
                      window.Comagic.addOfflineRequest({
                        name: copyData.name || '',
                        phone: copyData.phone || '',
                      });
                    }
                  } else if (copyData.type === 'whatsapp') {
                    const chatData = {
                      url: window.location.href,
                      title: document.title,
                      channel: 'whatsapp',
                      Client_name: copyData.name,
                      phone: copyData.phone.replace(/\D/g, ''),
                    };
                    Api.post('https://api.chat2desk.com/webhooks/smart_script/MeCzLzE', chatData);
                  }
                }
                this.$emit('complete');
              }
            });
        },
        submit() {
          this.isSubmited = true;
          if (this.formData.type) {
            this.submitEl.classList.add(`connect-${this.formData.type}`);
          }
          if (this.isNameValid && (!this.$refs.agreeInput || this.isAgree) && this.formComplete) {
            this.formSubmit();
          }
          this.showError = !this.formComplete;
        },
        completeForm(phone) {
          this.formComplete = true;
          this.formData.phone = phone;
        },
        acceptForm(value) {
          this.formComplete = false;
          if (value.length === 0) {
            this.showError = false;
          }
        },
        onClassChange(classAttrValue) {
          const classList = classAttrValue.split(' ');
          if (classList.includes('popup-callback--new')) {
            this.isEmail = false;
            if (!classList.includes('popup-callback--calculator')) {
              this.isCalculator = false;
              const customParams = window.LCDPopupData;
              this.formData.question = null;
              this.formData.custom_id = customParams && customParams.id ? customParams.id : 'popup-callback-id';
              this.formData.custom_title = customParams && customParams.title ? customParams.title : 'popup-callback-title';
            }
            this.isNew = true;
            this.title = this.object.common;
          } else if (classList.includes('popup-callback--calculator')) {
            this.isCalculator = true;
            this.isEmail = false;
            this.isNew = true;
            const newValue = JSON.stringify(window.calculatorPopupData, null, ' ');
            this.formData.question = newValue.slice(1, newValue.length - 1).replace(/"/g, '').replace(/,/g, '.');
            this.title = this.object.presentation;
            this.$el.classList.add('popup-callback--new');
          } else {
            this.isEmail = false;
            this.isCalculator = false;
            this.formData.question = null;
            this.title = this.object.common;
          }
        },
      },
      computed: {
        isEmailValid() {
          return !this.$refs.emailInput || this.$refs.emailInput.checkValidity();
        },
        isAgree() {
          return this.formData.agree;
        },
        isAgreeAds() {
          return this.formData.agreeAds;
        },
        isNameValid() {
          return !this.nameValidation || !this.$refs.nameInput || (this.formData.name && this.formData.name.length > 0);
        },
      },
      mounted() {
        this.nameValidation = this.$refs.nameInput ? this.$refs.nameInput.getAttribute('data-required') === 'true' : false;
        this.submitEl = this.$refs.submitBtn;
        if (this.formData.type) {
          this.submitEl.classList.add(`connect-${this.formData.type}`);
        }
        this.initCaptcha();
        this.formSubmit = window.debounce(() => {
          if (window.captchaSitekey) {
            recaptcha.run(this.submitEl);
          } else {
            this.sendForm();
          }
        }, 200);
        this.observer = new window.MutationObserver((mutations) => {
          mutations.forEach((m) => {
            const newValue = m.target.getAttribute(m.attributeName);
            this.$nextTick(() => {
              this.onClassChange(newValue, m.oldValue);
            });
          });
        });

        this.observer.observe(this.$refs.popupCallback, {
          attributes: true,
          attributeOldValue: true,
          attributeFilter: ['class'],
        });
        this.customForm = this.$el.querySelector('form.popup-callback__form');
        this.customPhone = this.$el.querySelector('.popup-callback__phone input');
      },
      beforeDestroy() {
        this.observer.disconnect();
      },
    });
  }
}



// WEBPACK FOOTER //
// ./new-blocks/popup/callback/popup-callback.js